import { render, staticRenderFns } from "./largeWater.vue?vue&type=template&id=22bdaba2&scoped=true"
import script from "./largeWater.vue?vue&type=script&lang=js"
export * from "./largeWater.vue?vue&type=script&lang=js"
import style0 from "./largeWater.vue?vue&type=style&index=0&id=22bdaba2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bdaba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22bdaba2')) {
      api.createRecord('22bdaba2', component.options)
    } else {
      api.reload('22bdaba2', component.options)
    }
    module.hot.accept("./largeWater.vue?vue&type=template&id=22bdaba2&scoped=true", function () {
      api.rerender('22bdaba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/largeWater.vue"
export default component.exports